import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue3Lottie from 'vue3-lottie'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import './style/variable.css'
createApp(App).use(store).use(router).use(Vue3Lottie).use(FloatingVue).mount('#app')
